import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "account-container" }
const _hoisted_2 = { class: "select-all" }

import {
  ref,
  computed,
  onMounted,
  watch,
  nextTick,
} from "vue";
import { message } from "ant-design-vue";
import { TelegramClient } from "@/websocket/Client";


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteAccountModal',
  props: {
    visible: { type: Boolean }
  },
  emits: ["update:visible", "success"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// 使用计算属性处理 visible 状态
const isOpen = computed({
  get: () => props.visible,
  set: (value) => emit("update:visible", value),
});

const accounts = ref<any[]>([]);
const selectedRowKeys = ref<string[]>([]);

// 表格列定义
const columns = [
  {
    title: "账号",
    dataIndex: "strAccount",
    key: "account",
  },
  {
    title: "状态",
    dataIndex: "strStatus",
    key: "status",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime",
  },
];

// 状态颜色映射
const getStatusColor = (status: string) => {
  const statusMap: { [key: string]: string } = {
    "1": "orange", // 等待中
    "2": "blue", // 正在登录
    "3": "green", // 在线
    "4": "red", // 离线
  };
  return statusMap[status] || "default";
};

// 状态文本映射
const getStatusText = (status: string) => {
  const statusMap: { [key: string]: string } = {
    "1": "等待中",
    "2": "正在登录",
    "3": "在线",
    "4": "离线",
  };
  return statusMap[status] || "未知状态";
};

// 表格选择配置
const rowSelection = {
  selectedRowKeys,
  onChange: (selectedKeys: string[]) => {
    selectedRowKeys.value = selectedKeys;
  },
  rowKey: (record: any) => record.strAccount,
};

// 全选相关的计算属性
const isAllSelected = computed(() => {
  return (
    accounts.value.length > 0 &&
    selectedRowKeys.value.length === accounts.value.length
  );
});

const isIndeterminate = computed(() => {
  return (
    selectedRowKeys.value.length > 0 &&
    selectedRowKeys.value.length < accounts.value.length
  );
});

// 处理全选
const handleSelectAll = (e: any) => {
  selectedRowKeys.value = e.target.checked
    ? accounts.value.map((account) => account.strAccount)
    : [];
};

// 获取账号列表
const fetchAccounts = async () => {
  try {
    const username = localStorage.getItem("username");
    if (!username) {
      throw new Error("未找到登录用户名");
    }
    const client = TelegramClient.getInstance();
    const response = await client.getAccountList(username);

    if (response && Array.isArray(response.list)) {
      accounts.value = response.list;
    }
  } catch (error) {
    console.error("获取账号列表错误:", error);
    message.error("获取账号列表失败");
  }
};

// 修改 handleCancel 函数
const handleCancel = () => {
  selectedRowKeys.value = [];
  nextTick(() => {
    emit("update:visible", false);
  });
};

// 修改 handleDelete 函数
const handleDelete = async () => {
  if (selectedRowKeys.value.length === 0) {
    message.warning("请选择要删除的账号");
    return;
  }

  try {
    const username = localStorage.getItem("username");
    if (!username) {
      throw new Error("未找到登录用户名");
    }

    const client = TelegramClient.getInstance();
    for (const account of selectedRowKeys.value) {
      const result = await client.deleteAccount(username, account);
      if (!result || result.code !== 1) {
        // 假设成功状态码为0
        throw new Error(
          `删除账号 ${account} 失败: ${result?.message || "未知错误"}`
        );
      }
    }

    message.success("删除成功");
    selectedRowKeys.value = [];
    nextTick(() => {
      emit("success");
      emit("update:visible", false);
    });
  } catch (error) {
    console.error("删除账号错误:", error);
    message.error(error instanceof Error ? error.message : "删除账号失败");
  }
};

// 监听模态框的显示状态
watch(
  () => props.visible,
  (newVisible) => {
    if (newVisible) {
      console.log("打开了删除账号弹窗");
      fetchAccounts();
    }
  }
);

// 可以保留 onMounted，但它只会在组件第一次加载时执行一次
onMounted(() => {
  console.log("删除账号组件被挂载");
});

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: isOpen.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    title: "删除账号",
    onCancel: handleCancel,
    onOk: handleDelete,
    okText: "删除",
    cancelText: "关闭",
    width: "800px",
    maskClosable: false,
    keyboard: true,
    destroyOnClose: true,
    focusTriggerAfterClose: true,
    autofocus: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("h3", null, "账号列表", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_checkbox, {
            onChange: handleSelectAll,
            checked: isAllSelected.value,
            indeterminate: isIndeterminate.value
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" 全选 ")
            ])),
            _: 1
          }, 8, ["checked", "indeterminate"])
        ]),
        _createVNode(_component_a_table, {
          columns: columns,
          "data-source": accounts.value,
          "row-selection": rowSelection,
          pagination: { pageSize: 10 },
          "row-key": (record) => record.strAccount
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'status')
              ? (_openBlock(), _createBlock(_component_a_tag, {
                  key: 0,
                  color: getStatusColor(record.strStatus)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getStatusText(record.strStatus)), 1)
                  ]),
                  _: 2
                }, 1032, ["color"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data-source", "row-key"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})